import { useEffect, useState } from "react";
import { router, usePage } from "@inertiajs/react";
import {
  dailyNavigation,
  isCollectionPath,
  navigationSection,
  returnToCollection,
} from "@/lib/navigation";

// Store only collection URLs, separately for each company/location. The
// record route stays canonical; the browser's own history retains scroll state.
export function useCollectionOrigin() {
  const {
    url,
    props: { auth, notification_parent },
  } = usePage();
  const section = navigationSection(
    url,
    auth.location?.id,
    notification_parent?.section,
  );
  const fallback =
    dailyNavigation(auth).find((item) => item.key === section)?.href || "";
  const key = `collection-origin:${auth.account?.id}:${auth.location?.id}`;
  const [saved, setSaved] = useState<{ url: string; top: number } | null>(null);
  useEffect(() => {
    try {
      if (isCollectionPath(url)) {
        const save = () =>
          window.sessionStorage.setItem(
            key,
            JSON.stringify({ url, top: window.scrollY }),
          );
        save();
        const stop = router.on("before", save);
        return stop;
      }
      const stored = JSON.parse(window.sessionStorage.getItem(key) || "null");
      setSaved(
        stored &&
          typeof stored.url === "string" &&
          Number.isFinite(stored.top) &&
          stored.top >= 0
          ? stored
          : null,
      );
    } catch {
      setSaved(null);
    }
  }, [key, url]);
  const href = returnToCollection(
    saved?.url || null,
    url,
    fallback,
    notification_parent?.section,
  );
  return {
    href,
    restoreScroll: () => {
      if (saved && href === saved.url)
        requestAnimationFrame(() =>
          window.scrollTo({ top: saved.top, behavior: "instant" }),
        );
    },
  };
}
